import "./polyfills";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-xhr-backend";
import {createTheme, initializeIcons, IPartialTheme, loadTheme, ThemeProvider,} from "@fluentui/react";
import React from "react";
import {createRoot} from "react-dom/client";
import {initReactI18next} from "react-i18next";
import {BrowserRouter} from "react-router-dom";
import App from "./App";
import {LanguageContextEntry} from "./contexts/LanguageContext";
import {en} from "./locales/en";
import {hr} from "./locales/hr";
import {it} from "./locales/it";
import {unregister} from "./registerServiceWorker";
import "./styles/index.css";
import {ApolloClient, ApolloProvider, createHttpLink, InMemoryCache,} from "@apollo/client";
import {setContext} from "@apollo/client/link/context";
import {LocalStorageWrapper, persistCache} from "apollo3-cache-persist";
import {ElectronWrapper} from "./components/ElectronWrapper";
import {configureAxios} from "./helpers/ConfigureAxios";
import {prepareEditorDrafts} from "./helpers/EditorDraftStore";

console.warn = (message: string) => {
};

const useProxy = localStorage.getItem("useProxy");

export const ticketTypes = [
    "",
    "Programiranje",
    "Servis",
    "Podrška",
    "Savjetovanje",
    "Nadogradnja",
    "AI/Codex",
    "Greška Datalab",
    "Greška Onix",
    "Ponuda"
];

export const nf = new Intl.NumberFormat("hr-HR", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
});

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    // init i18next
    .init({
        lng: "hr",
        debug: false,

        keySeparator: false,

        interpolation: {
            escapeValue: false,
        },
        resources: {
            hr: {translation: hr},
            en: {translation: en},
            it: {translation: it},
        },
        react: {
            useSuspense: false,
        },
        nsSeparator: false,
        contextSeparator: undefined,
        pluralSeparator: undefined,
    });

const t: IPartialTheme = {};

if (window.location.hostname.indexOf("staging") != -1) {
    t.palette = {
        themePrimary: "#ff8700",
        themeLighterAlt: "#fffaf5",
        themeLighter: "#ffecd6",
        themeLight: "#ffdbb3",
        themeTertiary: "#ffb866",
        themeSecondary: "#ff961f",
        themeDarkAlt: "#e67a00",
        themeDark: "#c26700",
        themeDarker: "#8f4c00",
        neutralLighterAlt: "#faf9f8",
        neutralLighter: "#f3f2f1",
        neutralLight: "#edebe9",
        neutralQuaternaryAlt: "#e1dfdd",
        neutralQuaternary: "#d0d0d0",
        neutralTertiaryAlt: "#c8c6c4",
        neutralTertiary: "#c2c2c2",
        neutralSecondary: "#858585",
        neutralPrimaryAlt: "#4b4b4b",
        neutralPrimary: "#333333",
        neutralDark: "#272727",
        black: "#1d1d1d",
        white: "#ffffff",
    };
} else if (
    (window.location.hostname.indexOf("localhost") != -1 ||
        window.location.hostname.indexOf("127.0.0.1") != -1) &&
    !useProxy
) {
    t.palette = {
        themePrimary: "#007700",
        themeLighterAlt: "#f0faf0",
        themeLighter: "#c4e9c4",
        themeLight: "#96d696",
        themeTertiary: "#46ae46",
        themeSecondary: "#108810",
        themeDarkAlt: "#006c00",
        themeDark: "#005b00",
        themeDarker: "#004300",
        neutralLighterAlt: "#faf9f8",
        neutralLighter: "#f3f2f1",
        neutralLight: "#edebe9",
        neutralQuaternaryAlt: "#e1dfdd",
        neutralQuaternary: "#d0d0d0",
        neutralTertiaryAlt: "#c8c6c4",
        neutralTertiary: "#c2c2c2",
        neutralSecondary: "#858585",
        neutralPrimaryAlt: "#4b4b4b",
        neutralPrimary: "#333333",
        neutralDark: "#272727",
        black: "#1d1d1d",
        white: "#ffffff",
    };
} else {
    t.palette = {
        themePrimary: "#702a7a",
        themeLighterAlt: "#f9f3fa",
        themeLighter: "#e7d1ea",
        themeLight: "#d2add7",
        themeTertiary: "#a76aaf",
        themeSecondary: "#813a8a",
        themeDarkAlt: "#66256e",
        themeDark: "#56205d",
        themeDarker: "#3f1745",
        neutralLighterAlt: "#faf9f8",
        neutralLighter: "#f3f2f1",
        neutralLight: "#edebe9",
        neutralQuaternaryAlt: "#e1dfdd",
        neutralQuaternary: "#d0d0d0",
        neutralTertiaryAlt: "#c8c6c4",
        neutralTertiary: "#c2c2c2",
        neutralSecondary: "#858585",
        neutralPrimaryAlt: "#4b4b4b",
        neutralPrimary: "#333333",
        neutralDark: "#272727",
        black: "#1d1d1d",
        white: "#ffffff",
    };
}

// if (localStorage.getItem("darkTheme")) {
//     t = AzureThemeDark;
//     t.palette ??= {};
//     if (t.palette) {
//         t.palette = {
//             ...t.palette,
//             ...{
//                 themePrimary: '#702a7a',
//                 themeLighterAlt: '#f9f3fa',
//                 themeLighter: '#e7d1ea',
//                 themeLight: '#d2add7',
//                 themeTertiary: '#a76aaf',
//                 themeSecondary: '#813a8a',
//                 themeDarkAlt: '#66256e',
//                 themeDark: '#56205d',
//                 themeDarker: '#3f1745',
//                 neutralLighterAlt: '#faf9f8',
//                 neutralLighter: '#f3f2f1',
//                 neutralLight: '#edebe9',
//                 neutralQuaternaryAlt: '#e1dfdd',
//                 neutralQuaternary: '#d0d0d0',
//                 neutralTertiaryAlt: '#c8c6c4',
//                 neutralTertiary: '#c2c2c2',
//                 neutralSecondary: '#858585',
//                 neutralPrimaryAlt: '#4b4b4b',
//                 neutralPrimary: '#333333',
//                 neutralDark: '#272727',
//                 black: '#1d1d1d',
//                 white: '#ffffff',
//             }
//         }
//     }
// }

t.fonts = {
    superLarge: {
        fontFamily: "Raleway, sans-serif",
    },
    large: {
        fontFamily: "Raleway, sans-serif",
    },
    medium: {
        fontFamily: "Raleway, sans-serif",
    },
    mediumPlus: {
        fontFamily: "Raleway, sans-serif",
    },
    mega: {
        fontFamily: "Raleway, sans-serif",
    },
    small: {
        fontFamily: "Raleway, sans-serif",
    },
    smallPlus: {
        fontFamily: "Raleway, sans-serif",
    },
    tiny: {
        fontFamily: "Raleway, sans-serif",
    },
    xLarge: {
        fontFamily: "Raleway, sans-serif",
    },
    xSmall: {
        fontFamily: "Raleway, sans-serif",
    },
    xxLarge: {
        fontFamily: "Raleway, sans-serif",
    },
};

t.defaultFontStyle = {
    fontFamily: "Raleway, sans-serif",
};

export const th = createTheme(t);

loadTheme(th);

export const theme = th;

configureAxios(useProxy ? `${useProxy}/api` : "/api");
initializeIcons();

const rootElement = document.getElementById("root")!;
const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");

const httpLink = createHttpLink({
    uri: useProxy ? `${useProxy}/graphql` : "/graphql",
});

const authLink = setContext((_, {headers}) => {
    // get the authentication token from local storage if it exists
    const token = localStorage.getItem("auth_token");
    // return the headers to the context so httpLink can read them
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : "",
        },
    };
});

const cache = new InMemoryCache();

persistCache({
    cache,
    storage: new LocalStorageWrapper(window.localStorage),
}).then(() => {
    const graphQLClient = new ApolloClient({
        cache: cache,
        link: authLink.concat(httpLink),
    });

    createRoot(rootElement).render(
        <ThemeProvider theme={th}>
            <BrowserRouter basename={baseUrl || "."}>
                <ElectronWrapper>
                    <ApolloProvider client={graphQLClient}>
                        <LanguageContextEntry>{() => <App/>}</LanguageContextEntry>
                    </ApolloProvider>
                </ElectronWrapper>
            </BrowserRouter>
        </ThemeProvider>,
    );

    localStorage.removeItem("updated");
    // Frees localStorage from editor drafts kept there by older versions.
    void prepareEditorDrafts();

    (window as any).token = () => {
        alert(localStorage.getItem("auth_token"));
    };
});
